import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'

// The module title is the screen heading (see BlockRenderer).
const ModuleIntro = ({ block, module }) => {
  const minutes = module?.estimatedMinutes
  return (
    <Box>
      {minutes > 0 && (
        <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '1.0625rem', color: colours.muted, mb: 2 }}>
          <AccessTimeIcon fontSize="small" aria-hidden="true" />
          About {minutes} {minutes === 1 ? 'minute' : 'minutes'}
        </Typography>
      )}
      {block.body && <Markdown sx={{ ...bodyText, mb: 2 }}>{block.body}</Markdown>}
      {module?.objectives?.length > 0 && (
        <>
          <Typography component="h3" sx={{ fontSize: '1.125rem', fontWeight: 700, mb: 1 }}>
            By the end of this module you will be able to:
          </Typography>
          <Box component="ul" sx={{ ...bodyText, m: 0, pl: 3 }}>
            {module.objectives.map((objective, index) => (
              <Box component="li" key={index} sx={{ mb: 0.75 }}>
                {objective}
              </Box>
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}

export default ModuleIntro
